module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/flag-45c5dd59152e08cc4dd51219bd91d13d.svg";